export enum ILessonMode{
    SINGLE="Single",
    PACK="Pack"
}